

















































































import { computed, defineComponent, Ref } from '@vue/composition-api';
import store from '@/store/index';
import { IWeatherStatus } from '@/interfaces/IWeatherStatus';
import useWeatherDataParser from '@/components/composers/useWeatherDataParser';

const WeatherPage: object = defineComponent({
  name: 'WeatherPage',
  setup() {
    const noData: string = 'b/d';
    const currentWeather: Ref<IWeatherStatus> = computed(() => store.state.currentWeather);

    return {
      noData,
      currentWeather,
      ...useWeatherDataParser(),
    };
  },
});
export default WeatherPage;
